module.exports = __webpack_public_path__ + "img/list-outlined-grey.542e1f1c.svg";